const RU = {
  'comms.tab.templates': 'Шаблоны',
  'comms.tab.log': 'Журнал отправок',
  'comms.tab.broadcast': 'Рассылка',
  'comms.tab.providers': 'Провайдеры',

  'comms.templates.title': 'Реестр шаблонов',
  'comms.templates.history': 'История версий',
  'comms.templates.historyHint':
    'Старые версии не удаляются: текст, который уже ушёл клиентам, должен остаться в истории. Откройте любую и сохраните — она станет новой версией',
  'comms.templates.opened': '— открыта',
  'comms.templates.newTitle': 'Новый шаблон',
  'comms.templates.versionShort': 'версия {version}',
  'comms.templates.savedVersion': 'Сохранено, версия {version}',
  'comms.templates.willBump': 'Сохранение заведёт версию {version}. Прежняя останется в истории',
  'comms.templates.willCreate': 'Шаблона с таким назначением, языком и каналом ещё нет — будет создан',
  'comms.templates.dropChanges': 'В открытом шаблоне есть несохранённые правки. Отбросить их?',
  'comms.templates.purpose': 'Назначение',
  'comms.templates.purposeHint': 'Что это за сообщение и когда оно уходит клиенту',
  'comms.templates.channelHint': '«Автоматически» — платформа выберет доступный канал сама',
  'comms.templates.bodyHint':
    'Пишите как человеку. Подстановки добавляйте кнопками ниже — они заменятся настоящими данными',
  'comms.templates.insertHint': 'Вставить в текст:',
  'comms.templates.preview': 'Так это увидит клиент',
  'comms.templates.length': 'Символов: {length}, SMS-сегментов: {segments}',
  'comms.templates.isService':
    'Служебное сообщение: уходит всем, кого касается, — согласие на маркетинг для него не требуется',
  'comms.templates.isMarketing':
    'Маркетинговое сообщение: уйдёт только тем, кто дал согласие на маркетинг. Вид задан назначением и не меняется',
  'comms.channel.auto': 'Автоматически',
  'comms.channel.sms': 'SMS',
  'comms.channel.whatsapp': 'WhatsApp',
  'comms.channel.push': 'Push-уведомление',
  'comms.channel.email': 'Электронная почта',
  'comms.locale.ru': 'Русский',
  'comms.locale.kk': 'Қазақша',
  'comms.templates.code': 'Код',
  'comms.templates.version': 'Версия',
  'comms.templates.kind': 'Тип',
  'comms.templates.channel': 'Канал',
  'comms.templates.locale': 'Язык',
  'comms.templates.body': 'Текст',
  'comms.templates.variables': 'Переменные',
  'comms.templates.variablesHint':
    'Только имена через запятую, без скобок: name, percent. Каждое имя обязано встречаться в тексте как {name} — иначе шаблон нельзя будет отправить.',
  'comms.templates.status': 'Статус',
  'comms.templates.save': 'Сохранить новую версию',
  'comms.templates.saved': 'Шаблон сохранён, создана новая версия',
  'comms.templates.new': 'Новый шаблон',
  'comms.templates.noCode':
    'Шаблон правится здесь и вступает в силу без выкладки кода: сохранение создаёт новую версию, старые отправки остаются со своей.',
  'comms.templates.kindHint':
    'Тип определяет, нужна ли проверка согласия. Границу «служебное против маркетингового» задаёт юрист, а не разработчик.',

  'comms.kind.service': 'служебное',
  'comms.kind.marketing': 'маркетинговое',

  'comms.subtitle': 'Шаблоны, рассылки по сегментам, журнал отправок и состояние каналов',
  'comms.log.noReason': 'канал не настроен',
  'comms.log.title': 'Журнал отправок',
  'comms.log.customer': 'Клиент',
  'comms.log.customerHint': 'Найдите по телефону или номеру автомобиля',
  'comms.single.title': 'Отправить одному клиенту',
  'comms.single.hint':
    'Точечное сообщение вне рассылки: подтвердить договорённость, ответить на звонок. Согласие проверяет сервер.',
  'comms.single.customer': 'Клиент',
  'comms.single.send': 'Отправить',
  'comms.single.queued': 'Сообщение поставлено в очередь',
  'comms.single.queuedTo': 'В очереди, канал: {channel}',
  'comms.single.suppressed': 'Сообщение не отправлено',
  'comms.single.suppressedWhy': 'Не отправлено: {reason}',

  'comms.log.recipient': 'Получатель',
  'comms.log.refresh': 'Обновить',
  'comms.log.status': 'Статус',
  'comms.log.basis': 'Основание согласия',
  'comms.log.consent': 'Согласие',
  'comms.log.reason': 'Основание отправки',
  'comms.log.suppressed': 'Причина отказа',
  'comms.log.provider': 'Провайдер',
  'comms.log.attempts': 'Попыток',
  'comms.log.created': 'Создано',
  'comms.log.hint':
    'По каждому сообщению видно, на каком основании оно отправлено и на какое согласие опиралось.',

  'comms.status.queued': 'в очереди',
  'comms.status.sending': 'отправляется',
  'comms.status.sent': 'отправлено',
  'comms.status.delivered': 'доставлено',
  'comms.status.failed': 'ошибка',
  'comms.status.suppressed': 'не отправлено',

  'comms.basis.service': 'служебное',
  'comms.basis.marketing_consent': 'согласие на маркетинг',
  'comms.basis.none': 'нет основания',

  'comms.broadcast.title': 'Рассылка по сегменту',
  'comms.broadcast.segment': 'Сегмент',
  'comms.broadcast.template': 'Шаблон',
  'comms.broadcast.reason': 'Основание',
  'comms.broadcast.send': 'Запустить рассылку',
  'comms.broadcast.result':
    'Получателей {requested}, поставлено в очередь {queued}, не отправлено {suppressed}',
  'comms.broadcast.empty':
    'В сегменте никого: не отправлено ни одного сообщения. Проверьте условия сегмента и маркетинговые согласия.',
  'comms.broadcast.mode.live': 'состав живого сегмента посчитан на момент запуска',
  'comms.broadcast.mode.scheduled': 'состав взят из последней пересборки сегмента',
  'comms.broadcast.variables': 'Значения переменных шаблона',
  'comms.broadcast.variablesNone': 'В выбранном шаблоне переменных нет',
  'comms.broadcast.variablesHint':
    'Одно значение на всю рассылку. Шаблон не отправится, пока не заполнены все переменные.',
  'comms.broadcast.suppressedBy': 'Почему не отправлено',
  'comms.broadcast.report': 'Итог рассылки',
  'comms.broadcast.recipients': 'Получателей в сегменте',
  'comms.broadcast.queued': 'Поставлено в очередь',
  'comms.broadcast.notSent': 'Не отправлено',
  'comms.broadcast.hint':
    'Состав берётся так же, как на вкладке «Состав» сегмента. Клиенты без маркетингового согласия отсеиваются на уровне сегмента, поэтому до проверки в рассылке обычно не доходят — в отчёте ниже видно, что осталось.',

  'comms.providers.title': 'Состояние каналов',
  'comms.providers.channel': 'Канал',
  'comms.providers.name': 'Адаптер',
  'comms.providers.state': 'Состояние',
  'comms.providers.detail': 'Подробности',
  'comms.providers.ok': 'работает',
  'comms.providers.down': 'недоступен',

  'comms.common.loading': 'Загрузка…',
  'comms.common.nothing': 'Ничего не найдено',
  'comms.tab.triggers': 'Сценарии',
  'comms.trig.title': 'Сценарии: событие → шаблон → канал',
  'comms.trig.hint': 'Сообщение уходит само, когда в платформе происходит событие. Условия, задержка и частота настраиваются здесь, без разработчика.',
  'comms.trig.new': 'Новый сценарий',
  'comms.trig.edit': 'Сценарий',
  'comms.trig.name': 'Название',
  'comms.trig.event': 'Событие',
  'comms.trig.template': 'Шаблон',
  'comms.trig.channel': 'Канал',
  'comms.trig.channel.origin': 'Туда, откуда писал клиент',
  'comms.trig.locale': 'Язык',
  'comms.trig.audience': 'Кому',
  'comms.trig.audience.customer': 'Клиенту из события',
  'comms.trig.audience.employee': 'Сотруднику из поля события',
  'comms.trig.audience.role': 'Всем сотрудникам с ролью',
  'comms.trig.field': 'Поле события',
  'comms.trig.role': 'Роль',
  'comms.trig.conditions': 'Условия',
  'comms.trig.conditionsNone': 'Без условий — на каждое событие',
  'comms.trig.addCondition': 'Добавить условие',
  'comms.trig.value': 'Значение',
  'comms.trig.remove': 'Убрать',
  'comms.trig.noVisitSince': 'Только если клиент не приезжал после события (возврат)',
  'comms.trig.subscriptionActive': 'Только если подписка на момент отправки активна',
  'comms.trig.delay': 'Задержка',
  'comms.trig.delayHint': 'Отрицательная — только от даты из события: «за 3 дня до конца периода»',
  'comms.trig.anchor': 'Отсчитывать от',
  'comms.trig.anchorEvent': 'момента события',
  'comms.trig.cooldown': 'Не чаще, чем раз в',
  'comms.trig.quietHours': 'Не отправлять отложенное клиенту ночью (перенос на 09:00)',
  'comms.trig.status': 'Статус',
  'comms.trig.status.active': 'работает',
  'comms.trig.status.paused': 'на паузе',
  'comms.trig.status.archived': 'в архиве',
  'comms.trig.save': 'Сохранить',
  'comms.trig.saved': 'Сценарий сохранён',
  'comms.trig.runs': 'Запуски',
  'comms.trig.runs30': 'За 30 дней',
  'comms.trig.runsEmpty': 'Запусков пока не было',
  'comms.trig.run.scheduled': 'отложено',
  'comms.trig.run.sent': 'отправлено',
  'comms.trig.run.suppressed': 'не отправлено',
  'comms.trig.run.skipped': 'пропущено',
  'comms.trig.run.failed': 'ошибка',
  'comms.trig.run.cancelled': 'отменено',
  'comms.trig.fireAt': 'Когда',
  'comms.trig.recipient': 'Получатель',
  'comms.trig.reason': 'Причина',
  'comms.trig.unit.minutes': 'минут',
  'comms.trig.unit.hours': 'часов',
  'comms.trig.unit.days': 'дней',
  'comms.trig.immediately': 'сразу',
  'comms.trig.op.eq': 'равно',
  'comms.trig.op.neq': 'не равно',
  'comms.trig.op.gte': 'не меньше',
  'comms.trig.op.lte': 'не больше',
  'comms.trig.op.gt': 'больше',
  'comms.trig.op.lt': 'меньше',
  'comms.trig.op.exists': 'заполнено',
  'comms.trig.op.missing': 'пусто',
  'comms.providers.inbound': 'Входящие за 30 дней',
  'comms.providers.inbound.forwarded': 'переданы в обращения: {n}',
  'comms.providers.inbound.ignored': 'отложены: {n}',
  'comms.providers.inbound.failed': 'ошибка: {n}',
  'comms.providers.inbound.received': 'ждут разбора: {n}',
  'comms.providers.webhook': 'Вебхук',
  'comms.providers.webhookSigned': 'подпись проверяется',
  'comms.providers.webhookClosed': 'не принимается',
  'comms.providers.alertmanager': 'Оповещения Alertmanager',
  'comms.providers.alertmanagerOn': 'приёмник открыт по токену, оповещения уходят дежурным',
  'comms.providers.alertmanagerOff': 'не настроено: нет MOIKA_ALERTMANAGER_TOKEN — оповещения никому не придут',
  'comms.log.staff': 'Сотрудник',
  'comms.common.required': 'Заполните обязательные поля',
  'comms.common.forbidden': 'Недостаточно прав для этого раздела',

} as const;

const KK: Record<keyof typeof RU, string> = {
  'comms.tab.templates': 'Үлгілер',
  'comms.tab.log': 'Жіберу журналы',
  'comms.tab.broadcast': 'Тарату',
  'comms.tab.providers': 'Провайдерлер',

  'comms.templates.title': 'Үлгілер тізілімі',
  'comms.templates.history': 'Нұсқалар тарихы',
  'comms.templates.historyHint':
    'Ескі нұсқалар жойылмайды: клиенттерге кеткен мәтін тарихта қалуы тиіс. Кез келгенін ашып сақтаңыз — ол жаңа нұсқа болады',
  'comms.templates.opened': '— ашық',
  'comms.templates.newTitle': 'Жаңа үлгі',
  'comms.templates.versionShort': '{version}-нұсқа',
  'comms.templates.savedVersion': 'Сақталды, {version}-нұсқа',
  'comms.templates.willBump': 'Сақтау {version}-нұсқаны жасайды. Алдыңғысы тарихта қалады',
  'comms.templates.willCreate': 'Мұндай тағайындау, тіл және арна үлгісі әлі жоқ — жасалады',
  'comms.templates.dropChanges': 'Ашық үлгіде сақталмаған өзгерістер бар. Оларды тастау керек пе?',
  'comms.templates.purpose': 'Тағайындауы',
  'comms.templates.purposeHint': 'Бұл қандай хабарлама және ол клиентке қашан жіберіледі',
  'comms.templates.channelHint': '«Автоматты» — платформа қолжетімді арнаны өзі таңдайды',
  'comms.templates.bodyHint':
    'Адамға жазғандай жазыңыз. Қоюларды төмендегі батырмалармен қосыңыз — олар нақты деректермен ауысады',
  'comms.templates.insertHint': 'Мәтінге қою:',
  'comms.templates.preview': 'Клиент оны осылай көреді',
  'comms.templates.length': 'Таңба: {length}, SMS сегменті: {segments}',
  'comms.templates.isService':
    'Қызметтік хабарлама: қатысы бар барлық адамға барады — маркетингке келісім талап етілмейді',
  'comms.templates.isMarketing':
    'Маркетингтік хабарлама: тек маркетингке келісім бергендерге барады. Түрін тағайындау белгілейді, өзгермейді',
  'comms.channel.auto': 'Автоматты',
  'comms.channel.sms': 'SMS',
  'comms.channel.whatsapp': 'WhatsApp',
  'comms.channel.push': 'Push-хабарландыру',
  'comms.channel.email': 'Электрондық пошта',
  'comms.locale.ru': 'Орысша',
  'comms.locale.kk': 'Қазақша',
  'comms.templates.code': 'Коды',
  'comms.templates.version': 'Нұсқасы',
  'comms.templates.kind': 'Түрі',
  'comms.templates.channel': 'Арна',
  'comms.templates.locale': 'Тілі',
  'comms.templates.body': 'Мәтін',
  'comms.templates.variables': 'Айнымалылар',
  'comms.templates.variablesHint':
    'Тек аттар үтір арқылы, жақшасыз: name, percent. Әр ат мәтінде {name} түрінде кездесуі керек — әйтпесе үлгіні жіберу мүмкін емес.',
  'comms.templates.status': 'Күйі',
  'comms.templates.save': 'Жаңа нұсқаны сақтау',
  'comms.templates.saved': 'Үлгі сақталды, жаңа нұсқа жасалды',
  'comms.templates.new': 'Жаңа үлгі',
  'comms.templates.noCode':
    'Үлгі осында түзетіледі және кодты шығармай күшіне енеді: сақтау жаңа нұсқа жасайды.',
  'comms.templates.kindHint':
    'Түрі келісімді тексеру қажеттігін анықтайды. Шекараны заңгер белгілейді, әзірлеуші емес.',

  'comms.kind.service': 'қызметтік',
  'comms.kind.marketing': 'маркетингтік',

  'comms.subtitle': 'Үлгілер, сегмент бойынша тарату, жіберу журналы және арналар күйі',
  'comms.log.noReason': 'арна бапталмаған',
  'comms.log.title': 'Жіберу журналы',
  'comms.log.customer': 'Клиент',
  'comms.log.customerHint': 'Телефон немесе көлік нөмірі бойынша табыңыз',
  'comms.single.title': 'Бір клиентке жіберу',
  'comms.single.hint':
    'Таратудан тыс нүктелік хабарлама: келісімді растау, қоңырауға жауап беру. Келісімді сервер тексереді.',
  'comms.single.customer': 'Клиент',
  'comms.single.send': 'Жіберу',
  'comms.single.queued': 'Хабарлама кезекке қойылды',
  'comms.single.queuedTo': 'Кезекте, арна: {channel}',
  'comms.single.suppressed': 'Хабарлама жіберілмеді',
  'comms.single.suppressedWhy': 'Жіберілмеді: {reason}',

  'comms.log.recipient': 'Алушы',
  'comms.log.refresh': 'Жаңарту',
  'comms.log.status': 'Күйі',
  'comms.log.basis': 'Келісім негізі',
  'comms.log.consent': 'Келісім',
  'comms.log.reason': 'Жіберу негізі',
  'comms.log.suppressed': 'Бас тарту себебі',
  'comms.log.provider': 'Провайдер',
  'comms.log.attempts': 'Әрекеттер',
  'comms.log.created': 'Жасалды',
  'comms.log.hint':
    'Әр хабарлама бойынша қандай негізде жіберілгені және қандай келісімге сүйенгені көрінеді.',

  'comms.status.queued': 'кезекте',
  'comms.status.sending': 'жіберілуде',
  'comms.status.sent': 'жіберілді',
  'comms.status.delivered': 'жеткізілді',
  'comms.status.failed': 'қате',
  'comms.status.suppressed': 'жіберілмеді',

  'comms.basis.service': 'қызметтік',
  'comms.basis.marketing_consent': 'маркетингке келісім',
  'comms.basis.none': 'негіз жоқ',

  'comms.broadcast.title': 'Сегмент бойынша тарату',
  'comms.broadcast.segment': 'Сегмент',
  'comms.broadcast.template': 'Үлгі',
  'comms.broadcast.reason': 'Негіздеме',
  'comms.broadcast.send': 'Таратуды бастау',
  'comms.broadcast.result':
    'Алушылар {requested}, кезекке қойылды {queued}, жіберілмеді {suppressed}',
  'comms.broadcast.empty':
    'Сегментте ешкім жоқ: бірде-бір хабарлама жіберілмеді. Сегмент шарттарын және маркетингтік келісімдерді тексеріңіз.',
  'comms.broadcast.mode.live': 'тірі сегмент құрамы іске қосу сәтінде есептелді',
  'comms.broadcast.mode.scheduled': 'құрам сегменттің соңғы жинағынан алынды',
  'comms.broadcast.variables': 'Үлгі айнымалыларының мәндері',
  'comms.broadcast.variablesNone': 'Таңдалған үлгіде айнымалы жоқ',
  'comms.broadcast.variablesHint':
    'Барлық таратуға бір мән. Барлық айнымалы толтырылмайынша үлгі жіберілмейді.',
  'comms.broadcast.suppressedBy': 'Неге жіберілмеді',
  'comms.broadcast.report': 'Тарату қорытындысы',
  'comms.broadcast.recipients': 'Сегменттегі алушылар',
  'comms.broadcast.queued': 'Кезекке қойылды',
  'comms.broadcast.notSent': 'Жіберілмеді',
  'comms.broadcast.hint':
    'Құрам сегменттің «Құрамы» қойындысындағыдай алынады. Маркетингтік келісімі жоқ клиенттер сегмент деңгейінде сүзіледі, сондықтан таратудағы тексеруге әдетте жетпейді — төмендегі есепте не қалғаны көрінеді.',

  'comms.providers.title': 'Арналардың күйі',
  'comms.providers.channel': 'Арна',
  'comms.providers.name': 'Адаптер',
  'comms.providers.state': 'Күйі',
  'comms.providers.detail': 'Толығырақ',
  'comms.providers.ok': 'жұмыс істейді',
  'comms.providers.down': 'қолжетімсіз',

  'comms.common.loading': 'Жүктелуде…',
  'comms.common.nothing': 'Ештеңе табылмады',
  'comms.tab.triggers': 'Сценарийлер',
  'comms.trig.title': 'Сценарийлер: оқиға → үлгі → арна',
  'comms.trig.hint': 'Платформада оқиға болғанда хабарлама өзі жіберіледі. Шарттар, кідіріс және жиілік осында бапталады, әзірлеушісіз.',
  'comms.trig.new': 'Жаңа сценарий',
  'comms.trig.edit': 'Сценарий',
  'comms.trig.name': 'Атауы',
  'comms.trig.event': 'Оқиға',
  'comms.trig.template': 'Үлгі',
  'comms.trig.channel': 'Арна',
  'comms.trig.channel.origin': 'Клиент жазған арнаға',
  'comms.trig.locale': 'Тіл',
  'comms.trig.audience': 'Кімге',
  'comms.trig.audience.customer': 'Оқиғадағы клиентке',
  'comms.trig.audience.employee': 'Оқиға өрісіндегі қызметкерге',
  'comms.trig.audience.role': 'Рөлі бар барлық қызметкерге',
  'comms.trig.field': 'Оқиға өрісі',
  'comms.trig.role': 'Рөл',
  'comms.trig.conditions': 'Шарттар',
  'comms.trig.conditionsNone': 'Шартсыз — әр оқиғаға',
  'comms.trig.addCondition': 'Шарт қосу',
  'comms.trig.value': 'Мәні',
  'comms.trig.remove': 'Алып тастау',
  'comms.trig.noVisitSince': 'Клиент оқиғадан кейін келмесе ғана (қайтару)',
  'comms.trig.subscriptionActive': 'Жіберу сәтінде жазылым белсенді болса ғана',
  'comms.trig.delay': 'Кідіріс',
  'comms.trig.delayHint': 'Теріс мән — тек оқиғадағы күннен: «кезең соңына 3 күн қалғанда»',
  'comms.trig.anchor': 'Есептеу басы',
  'comms.trig.anchorEvent': 'оқиға сәтінен',
  'comms.trig.cooldown': 'Жиілігі, бір рет',
  'comms.trig.quietHours': 'Кейінге қалдырылғанды клиентке түнде жібермеу (09:00-ге ауыстыру)',
  'comms.trig.status': 'Күйі',
  'comms.trig.status.active': 'жұмыс істейді',
  'comms.trig.status.paused': 'кідіртілген',
  'comms.trig.status.archived': 'мұрағатта',
  'comms.trig.save': 'Сақтау',
  'comms.trig.saved': 'Сценарий сақталды',
  'comms.trig.runs': 'Іске қосулар',
  'comms.trig.runs30': '30 күнде',
  'comms.trig.runsEmpty': 'Іске қосулар әлі болған жоқ',
  'comms.trig.run.scheduled': 'кейінге қалды',
  'comms.trig.run.sent': 'жіберілді',
  'comms.trig.run.suppressed': 'жіберілмеді',
  'comms.trig.run.skipped': 'өткізілді',
  'comms.trig.run.failed': 'қате',
  'comms.trig.run.cancelled': 'бас тартылды',
  'comms.trig.fireAt': 'Қашан',
  'comms.trig.recipient': 'Алушы',
  'comms.trig.reason': 'Себебі',
  'comms.trig.unit.minutes': 'минут',
  'comms.trig.unit.hours': 'сағат',
  'comms.trig.unit.days': 'күн',
  'comms.trig.immediately': 'бірден',
  'comms.trig.op.eq': 'тең',
  'comms.trig.op.neq': 'тең емес',
  'comms.trig.op.gte': 'кем емес',
  'comms.trig.op.lte': 'артық емес',
  'comms.trig.op.gt': 'артық',
  'comms.trig.op.lt': 'кем',
  'comms.trig.op.exists': 'толтырылған',
  'comms.trig.op.missing': 'бос',
  'comms.providers.inbound': '30 күндегі кіріс',
  'comms.providers.inbound.forwarded': 'өтініштерге берілді: {n}',
  'comms.providers.inbound.ignored': 'кейінге қалды: {n}',
  'comms.providers.inbound.failed': 'қате: {n}',
  'comms.providers.inbound.received': 'талдауды күтуде: {n}',
  'comms.providers.webhook': 'Вебхук',
  'comms.providers.webhookSigned': 'қолтаңба тексеріледі',
  'comms.providers.webhookClosed': 'қабылданбайды',
  'comms.providers.alertmanager': 'Alertmanager ескертулері',
  'comms.providers.alertmanagerOn': 'қабылдағыш токенмен ашық, ескертулер кезекшілерге жіберіледі',
  'comms.providers.alertmanagerOff': 'бапталмаған: MOIKA_ALERTMANAGER_TOKEN жоқ — ескертулер ешкімге келмейді',
  'comms.log.staff': 'Қызметкер',
  'comms.common.required': 'Міндетті өрістерді толтырыңыз',
  'comms.common.forbidden': 'Бұл бөлімге құқық жеткіліксіз',

};

export type CommsKey = keyof typeof RU;
export type CommsLocale = 'ru' | 'kk';

const DICTS: Readonly<Record<CommsLocale, Record<CommsKey, string>>> = { ru: RU, kk: KK };

export type CommsTranslate = (key: CommsKey, params?: Record<string, string | number>) => string;

export function makeCommsT(locale: CommsLocale): CommsTranslate {
  const dict = DICTS[locale] ?? RU;
  return (key, params) => {
    const template = dict[key] ?? RU[key] ?? key;
    if (!params) return template;
    return template.replace(/\{(\w+)\}/g, (match, name: string) =>
      params[name] === undefined ? match : String(params[name]),
    );
  };
}

export function translateCommsError(locale: CommsLocale, code: string): string {
  const dict = DICTS[locale] ?? RU;
  return (dict as Record<string, string>)[`errors.${code}`] ?? code;
}
